import React from 'react';
import ReactDOM from 'react-dom';
import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { threadIdPreview } from './smartAssistUtils';
import type { ConversationEntry, RecentPanelRect } from './types';

export interface SmartAssistRecentPanelProps {
  focused: boolean;
  recentForPortal: ConversationEntry[];
  recentPanelRect: RecentPanelRect | null;
  recentPanelRef: React.RefObject<HTMLDivElement | null>;
  onOpen(entry: ConversationEntry): void;
}

export function SmartAssistRecentPanel({
  focused,
  recentForPortal,
  recentPanelRect,
  recentPanelRef,
  onOpen,
}: SmartAssistRecentPanelProps): React.ReactPortal | null {
  if (!focused || recentForPortal.length === 0 || !recentPanelRect) return null;

  return ReactDOM.createPortal(
    <div
      ref={recentPanelRef}
      className={clsx('smartAssist__recent', 'smartAssist__recent--portal')}
      style={{
        top: recentPanelRect.top,
        left: recentPanelRect.left,
        width: recentPanelRect.width,
      }}
    >
      <div className="smartAssist__recent-header">{i18n.translate('smartAssist.recentConversations')}</div>
      {recentForPortal.map((c) => (
        <button
          key={c.id}
          type="button"
          className="smartAssist__recent-item"
          title={c.conversationId ? `${c.text}\n${c.conversationId}` : c.text}
          onClick={() => {
            onOpen(c);
          }}
        >
          <FontAwesomeIcon icon={['fas', 'clock-rotate-left']} className="smartAssist__recent-icon" />
          <span className="smartAssist__recent-text">{c.text}</span>
          <span className="smartAssist__recent-meta">
            <span className="smartAssist__recent-date">{c.date}</span>
            {c.conversationId && (
              <span className="smartAssist__recent-id">{threadIdPreview(c.conversationId)}</span>
            )}
          </span>
        </button>
      ))}
    </div>,
    document.body,
  );
}
